module.exports = __webpack_public_path__ + "static/media/google_play_icon.a0845f24.png";